import { FaCity, FaCrown, FaRegStar } from 'react-icons/fa6'
import { FaShippingFast } from 'react-icons/fa'
import {
  MdOutlineAssignmentReturn,
  MdOutlineCardGiftcard,
  MdOutlineClose,
  MdOutlineCreditCard,
  MdOutlineEmail,
  MdOutlineFavoriteBorder,
  MdOutlineInventory2,
  MdOutlineLocalOffer,
  MdOutlineLocalShipping,
  MdOutlineLocationOn,
  MdOutlineLock,
  MdOutlineMenu,
  MdOutlinePerson,
  MdOutlinePhone,
  MdOutlineSchedule,
  MdOutlineSearch,
  MdOutlineShoppingBag,
  MdOutlineShoppingCart,
  MdOutlineStarBorder,
  MdOutlineSupportAgent,
  MdOutlineTune,
  MdOutlineVerified
} from 'react-icons/md'
import { CiGlobe } from 'react-icons/ci'
import { GrCatalog } from 'react-icons/gr'
import { type IconName } from 'ecosystem'
import { type IconBaseProps, type IconType } from 'react-icons'
import { useMemo } from 'react'

export const UIIcons: Record<IconName, IconType> = {
  FaCity,
  FaCrown,
  FaShippingFast,
  FaRegStar,
  MdOutlineLocalShipping,
  CiGlobe,
  GrCatalog,
  MdOutlineSearch,
  MdOutlineShoppingBag,
  MdOutlineShoppingCart,
  MdOutlinePerson,
  MdOutlineFavoriteBorder,
  MdOutlineMenu,
  MdOutlineClose,
  MdOutlineAssignmentReturn,
  MdOutlineLock,
  MdOutlineCreditCard,
  MdOutlineVerified,
  MdOutlinePhone,
  MdOutlineEmail,
  MdOutlineLocationOn,
  MdOutlineSchedule,
  MdOutlineSupportAgent,
  MdOutlineLocalOffer,
  MdOutlineCardGiftcard,
  MdOutlineInventory2,
  MdOutlineStarBorder,
  MdOutlineTune
}

export const useUIIcon = (iconName?: IconName) => {
  return useMemo(
    () => (iconName ? UIIcons[iconName] : (_iconBaseProps: IconBaseProps) => <>{false}</>),
    [iconName]
  )
}
